import type { CLIENT } from '@lt/api/dist/types/client';
import type { Dispatch, SetStateAction } from 'react';
import type { api } from 'src/api';

type Tuple<Prev, Next> = [Prev, Next];
export type ClientDataTuple = Tuple<CLIENT, CLIENT>;

export type HandleUpdateClient = typeof api.postClientUpdate;
export type ConfirmClientAction = (client: CLIENT) => void;
export type SetEmailWasChanged = Dispatch<SetStateAction<boolean>>;
export type SetNewPhone = Dispatch<SetStateAction<string | null>>;
export type SetShowConfirmationPhone = Dispatch<SetStateAction<boolean>>;

export enum ClientFormStep {
  AUTH = 'AUTH',
  CLIENT_INFO = 'CLIENT_INFO',
  PHONE_CONFIRMATION = 'PHONE_CONFIRMATION',
  MAIL_CONFIRMATION = 'MAIL_CONFIRMATION',
  SEND_SMS_CODE_AGAIN_FORM = 'SEND_SMS_CODE_AGAIN_FORM',
}
